/*
 * Project: forca
 * File Created: Wednesday, 1st December 2021 2:13:50 pm
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import React from 'react';

import Link from '@Components/link';
import Article from '@Pages/ditPKA/components/article';

import { RelatedArticlesProps } from './RelatedArticles.definition';

export const RelatedArticles = (props: RelatedArticlesProps) => {
	const { title, articles = [], linkToOverviewText, linkToOverview, isBlock = false, elementMargin } = props;

	if (articles.length <= 0) {
		return null;
	}

	const lastedArticles = isBlock ? articles : articles?.slice(0, 3);

	return (
		<div
			className={ [
				'DitPKA-RelatedArticles',
				isBlock ? 'DitPKA-RelatedArticles--isBlock' : '',
				elementMargin ? `mb-${elementMargin}` : ''
			].join(' ') }>
			<div className="DitPKA-Articles__List">
				<h3 className="DitPKA-Articles__List-Headline">
					{ title }
				</h3>

				{ lastedArticles.map((item, i: number) => (
					<React.Fragment key={ i }>
						<Article title={ item.overskrift } thumbnail={ item.thumbnail } pageLink={ item.pageLink } type="listed" />
					</React.Fragment>
				)) }

			</div>
			{ linkToOverviewText && linkToOverview && (
				<div className="DitPKA-RelatedArticles__Buttons">
					<Link className="square-button button-type-1" to={ linkToOverview }>
						{ linkToOverviewText }
					</Link>
				</div>
			) }
		</div>
	);
};

export default RelatedArticles;